module.exports = __webpack_public_path__ + "static/whitecartaggie-c3bbdb471156f2b2097968a159816c8b.png";